var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"elementRef",class:this.props.className,style:(this.props.style),on:{"click":_vm.clickHandle}},[_c('div',{class:'row1 ' + this.props.className1,style:(this.props.style1)},[_vm._v(_vm._s(_vm.text1))]),_vm._v(" "),_c('div',{class:'row2 ' + this.props.className2,style:(this.props.style2)},[_vm._v(_vm._s(_vm.text2))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52cd9a14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/DateLabelComponent.vue
// module id = null
// module chunks = 